import {
  CSW_ARROW_CLICK,
  CSW_PRODUCT_CLICK,
  CSW_SHOW_ALL_CLICK,
  CSW_SHOW_MORE_CLICK,
  type DynamicTrackingEvent,
  NEW_CSW,
  type TrackingEvent,
} from 'shared/experiments/consts'
import { isExperimentEnabled } from 'shared/experiments/utils/experiments'
import {
  bindDynamicEventsTracking,
  bindTrackingEvents,
} from 'shared/experiments/utils/tracking'
import { subscribe } from 'shared/store'
import { INIT_SLIDER } from 'shared/store/ducks/events'

const bindSliderTracking = () => {
  const staticElementsTracking: TrackingEvent[] = [
    {
      selector: '.e-newCsw .o-SliderHorizontal__nav',
      event: 'click',
      trackingEvent: CSW_ARROW_CLICK,
    },
    {
      selector: '.e-newCsw .o-SliderHorizontal__SliderHeader__title',
      event: 'click',
      trackingEvent: CSW_SHOW_ALL_CLICK,
    },
  ]

  const dynamicElementsTracking: DynamicTrackingEvent[] = [
    {
      parentElementSelector: '.e-newCsw',
      selector: '.o-ProductSliderItem',
      trackingEvent: CSW_PRODUCT_CLICK,
    },
    {
      parentElementSelector: '.e-newCsw',
      selector: '.o-SliderHorizontal__show-more .a-Button',
      trackingEvent: CSW_SHOW_MORE_CLICK,
    },
  ]

  let unsubscribeStatic: CallableFunction
  subscribe.after(INIT_SLIDER, () => {
    if (typeof unsubscribeStatic === 'function') {
      unsubscribeStatic()
    }

    // Bind events after the CSW slider pops in layout
    requestAnimationFrame(() => {
      unsubscribeStatic = bindTrackingEvents(staticElementsTracking)
    })
  })

  bindDynamicEventsTracking(dynamicElementsTracking)
}

export default () => {
  if (!isExperimentEnabled(NEW_CSW)) {
    return
  }

  bindSliderTracking()
}
